<div
  class="mx-auto mt-10 flex w-full max-w-[856px] flex-col items-center rounded-md border border-border-3 bg-white px-24 py-14"
>
  <p class="text-sm">{{ 'onboarding.step-x-of-y' | translate: { x: 3, y: 3 } }}</p>
  <p class="my-4 text-xl leading-none">
    {{ 'onboarding.select-products-to-assign-chart-to' | translate }}
  </p>

  <div class="mt-10 flex w-full flex-col gap-10">
    <button
      class="flex items-center gap-6 rounded-md border border-border-3 px-4 py-6 text-left transition-all hover:border-primary"
      [ngClass]="{ 'border-primary': selectedMethod() === 0 }"
      (click)="selectedMethod.set(0)"
    >
      @if (selectedMethod() === 0) {
        <div class="size-6 shrink-0 rounded-full border-[6px] border-primary bg-white"></div>
      } @else {
        <div class="size-6 shrink-0 rounded-full bg-border-6"></div>
      }

      <div class="flex grow flex-col gap-2">
        <p class="text-lg leading-none">{{ 'common.all' | translate }}</p>
        <p class="text-[15px] leading-[24px] text-text-2">
          {{ 'onboarding.apply-this-chart-to-all-products' | translate }}
        </p>
      </div>
    </button>

    <div
      class="flex flex-col gap-4 rounded-md border border-border-3 px-4 py-6 transition-all hover:border-primary"
      [ngClass]="{ 'border-primary': selectedMethod() === 1 }"
    >
      <button class="flex items-center gap-6 text-left" (click)="selectedMethod.set(1)">
        @if (selectedMethod() === 1) {
          <div class="size-6 shrink-0 rounded-full border-[6px] border-primary bg-white"></div>
        } @else {
          <div class="size-6 shrink-0 rounded-full bg-border-6"></div>
        }

        <div class="flex grow flex-col gap-2">
          <p class="text-lg leading-none">{{ 'common.selected' | translate }}</p>
          <p class="text-[15px] leading-[24px] text-text-2">
            {{ 'onboarding.select-products-to-apply-this-chart-to' | translate }}
          </p>
        </div>
      </button>

      <div
        class="flex flex-col gap-2 transition-all"
        [ngClass]="selectedMethod() === 1 ? 'opacity-1' : 'hidden opacity-0'"
      >
        <app-search-items condition="products" />
      </div>
    </div>
  </div>

  <div class="mt-10 flex gap-6 self-start">
    <button mat-button (click)="back.emit()">
      {{ 'common.back' | translate }}
    </button>

    <button mat-flat-button (click)="onContinue()" [disabled]="continueDisabled() || loading()">
      {{ (loading() ? 'onboarding.assigning...' : 'common.continue') | translate }}
    </button>
  </div>
</div>
